<template>
  <div class="block-blog-expert">
    <div class="block-blog-expert__articles">
      <div v-for="article of articlesData" :key="article.id" class="block-blog-expert__article">
        <SlotLink
          :url="article?.full_slug"
        >
          <AtomImage
            v-if="getContent(article, 'blog_preview_image')"
            :data="getContent(article, 'blog_preview_image')"
            class="block-blog-expert__article__image"
          />
          <p v-if="getContent(article, 'date')" class="block-blog-expert__article__date">
            {{ getContent(article, 'date') }}
          </p>
          <p
            v-if="getContent(article, 'text_teaser')"
            class="block-blog-expert__article__title"
          >
            {{ getContent(article, 'text_teaser') }}
          </p>
          <SlotLink
            v-if="article?.full_slug"
            class="block-blog-expert__article__link"
            :url="article?.full_slug"
          >
            {{ useTranslation('general', 'read_article') }}
          </SlotLink>
        </SlotLink>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const storyblokApi = useStoryblokApi();
const { dayjs } = useDayJs();
const storyStore = useStoryStore();
const currentStory = computed(() => storyStore.getCurrentStory);
const uuidExpert = currentStory.value.story.uuid;

const getContent = (data, key) => {
    if (data && key === 'date' && data.first_published_at) {
        return dayjs(data?.first_published_at).format('MMMM YYYY').toUpperCase();
    } if (data) {
        return data?.content?.[key];
    }
    return false;
};

const getArticles = async () => {
    try {
        const { data } = await storyblokApi.get('cdn/stories/', {
            starts_with: 'blogs/',
            version: 'published',
            filter_query: {
                expert: {
                    in: uuidExpert,
                },
            },
        });
        return data?.stories;
    } catch (e) {
        useSentryError(e);
        return e;
    }
};

const articlesData = await getArticles();
</script>

<style lang="scss">
.block-blog-expert {
    @include grid-columns(2, 16);
    @include fluid('margin-bottom', 60px, 120px);

    color: $C_GREEN_DARK;

    @include tablet  {
        @include grid-columns(1, 12);
    }
    @include mobile  {
        @include grid-columns(1, 6);
    }

}

.block-blog-expert__articles {
    @include grid-layout(12,34px);

    padding-top: 50px;
    row-gap: 34px;

    @include mobile {
        @include grid-layout(6,0px);
    }
}
.block-blog-expert__article {
    grid-column-end: span 3;

    @include tablet  {
        grid-column-end: span 6;
    }
}
.block-blog-expert__article__image {
    @include fluid('padding-bottom', 10px, 20px);

    img {
        border-radius: 12px;
        aspect-ratio: 31/23;
        object-fit: cover;
    }

}
.block-blog-expert__article__date {
    @include typo-font('regular');
    @include typo-size('nav');

    margin-bottom: 10px;
    color: $C_GREY_DARK;
}
.block-blog-expert__article__title {
    @include typo-font('light');
    @include typo-size('lead');
    @include fluid('margin-bottom', 6px, 20px);

    color: $C_GREEN_DARK;
}
.block-blog-expert__article__link {
    @include typo-font('italic');
    @include typo-size('a');

    color: $C_PRIMARY;
    transition: color 0.15s ease-in-out;

    &:hover {
        color: $C_SECONDARY;
    }
}
</style>
